import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { getOrganizations } from '../../../actions/api';
import Icon from '../../../components/Icon';
import * as types from '../../../constants/ActionTypes';
import { withNewOrganizationModal } from './NewOrganizationModal';
class OrganizationsList extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loaded: false,
            organizations: [],
        };
        this.fetchOrganizations = () => {
            this.props.dispatch(getOrganizations()).then((action) => {
                if (action.type === types.GET_ORGANIZATIONS_SUCCESS) {
                    this.setState({
                        loaded: true,
                        organizations: action.response.data,
                    });
                }
            });
        };
        this.addOrganizationCallback = (id, name) => {
            this.props.history.push(this.props.match.url + '/' + name);
        };
    }
    componentDidMount() {
        this.fetchOrganizations();
    }
    render() {
        const { /*onNewOrganizationClick, */ match, t } = this.props;
        const { loaded, organizations } = this.state;
        return (_jsxs("div", { className: "container", children: [_jsx("h3", { className: "h5 text-muted mb-4", children: t('organizations.listOfOrganizations') }), !loaded ? (_jsxs("div", { className: "loading-container", children: [_jsx(Icon, { name: "spinner", pulse: true, fixedWidth: true, size: "2x" }), _jsxs("span", { className: "sr-only", children: [t('loading'), "..."] })] })) : (_jsx("div", { children: organizations.length === 0 ? (_jsx("div", { className: "text-center", children: t('organizations.noFoundYet') })) : (_jsx(ListGroup, { children: organizations.map((organization) => (
                        // @ts-expect-error TS2339: Property id does not exist on type never
                        _jsxs(ListGroupItem, { className: "d-inline-flex", children: [_jsx(Link, { to: `${match.url.replace(/\/$/, '')}/${organization.name}`, className: "d-block flex-grow-1", children: organization.name }), _jsx("span", { children: 
                                    // @ts-expect-error TS2339: Property usersCount does not exist on type never
                                    t('organizations.memberCount', { count: organization.usersCount }) })] }, organization.id))) })) }))] }));
    }
}
// const mapStateToProps = state => ({
// });
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default withNewOrganizationModal(connect(void 0 /*mapStateToProps*/, mapDispatchToProps)(withTranslation()(OrganizationsList)));
